import React from 'react';

/**
 * VipBadge — displays the WorldVibe VIP EXCLUSIVE ACCESS shield next to any
 * VIP user's name. Auto-hides when `active` is false, so callers can pass
 * `active={user?.is_vip}` and it renders only for members.
 *
 * The badge is served locally from /public/vip-badge.png (48 KB, 256px)
 * so it renders instantly and works offline / on the PWA.
 *
 * Sizes:  sm = 16px, md = 22px (default), lg = 32px, xl = 56px
 */
export const VIP_BADGE_SRC = '/vip-badge.png';

const SIZES = { sm: 16, md: 22, lg: 32, xl: 56 };

export default function VipBadge({
  active = true,
  size = 'md',
  animated = false,
  className = '',
  title = 'WorldVibe VIP · Exclusive Access',
  ...rest
}) {
  if (!active) return null;
  const px = SIZES[size] || SIZES.md;
  return (
    <img
      src={VIP_BADGE_SRC}
      alt="VIP"
      width={px}
      height={px}
      title={title}
      data-testid={rest['data-testid'] || 'vip-badge'}
      className={`inline-block shrink-0 select-none ${animated ? 'vip-badge-shimmer' : ''} ${className}`}
      style={{
        width: px,
        height: px,
        // Preserve the shield's aspect (source is roughly square-ish crop of a tall shield)
        objectFit: 'contain',
        filter: 'drop-shadow(0 0 6px rgba(212,175,55,0.45)) drop-shadow(0 0 12px rgba(52,120,255,0.35))',
      }}
      {...rest}
    />
  );
}
